<template>
  <div>
    <el-dialog
      v-if="visible"
      width="600px"
      :title="$l('dialog_title_setFba')"
      :visible="visible"
      @close="() => $refs.main.cancel()"
    >
      <Main ref="main" @close="close" @reload="$emit('reload')" :data="data" />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
